import type { ReactNode } from 'react';
import { Card, Collapse, Link } from '@ksyos/design-system';

type MonitoringCardFooterProps = {
    children: ReactNode;
    isClosedText: string;
    isOpen: boolean;
    isOpenText: string;
    onClick: () => void;
};

export function MonitoringCardFooter(props: MonitoringCardFooterProps): JSX.Element {
    const { children, isClosedText, isOpen, isOpenText, onClick } = props;

    return (
        <Card.Footer>
            <Collapse isOpen={isOpen}>{children}</Collapse>
            <Link
                color="minimal"
                fontWeight="normal"
                iconLeft={isOpen ? 'caret-up' : 'caret-down'}
                onClick={onClick}
                variant="button"
            >
                {isOpen ? isOpenText : isClosedText}
            </Link>
        </Card.Footer>
    );
}
